import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import { FaCheck, FaTimes, FaRegSave } from "react-icons/fa";
import BasicInput from "../edittext/basicInput/basicInput";
import "./ProductForm.css"; // استایل سفارشی

import LinearLayout from "../layout/LinearLayout";
import ButtonSimp from "../button";
import FileInput from "../edittext/fileInput/fileInput";
import SelectBox from "../edittext/selectbox/SelectBox";
import BootImage from "../Image/bootImg/bootImg";
import Badge from "../badge/badge";

const CategoryForm = ({ categories, category, onClose, onSuccess }) => {
  const [categoryState, setCategory] = useState(category || {});
  const [name, setName] = useState(category?.name || "");
  const [slug, setSlug] = useState(category?.slug || "");
  const [parentId, setParentId] = useState(category?.parentId || "");
  const [attributes, setAttributes] = useState(category?.attributes || []);
  const [allAttributes, setAllAttributes] = useState([]); // همه‌ی ویژگی‌های موجود از سرور
  const [addingAttr, setAddingAttr] = useState(false);
  const [newAttrName, setNewAttrName] = useState("");
  const [newAttrType, setNewAttrType] = useState("text");
  const [filterable, setFilterable] = useState("No");
  const [newAttrOptions, setNewAttrOptions] = useState("");
  const [image, setImage] = useState(category?.image || "");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedParent, setSelectedParent] = useState("");

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]); // فایل انتخاب‌شده ذخیره میشه
  };
  const geturlimage = (img) => {
    console.log("imgurl1", img);
  };
  //  console.log("imgurl12", image);
  useEffect(() => {
    if (category) {
      setName(category.name || "");
      setSlug(category.slug || "");
      setParentId(category.parentId || "");
      setAttributes(category.attributes || []);
      setImage(category.image || ""); // ✅ اینجا درست شد
    } else {
      setName("");
      setSlug("");
      setParentId("");
      setAttributes([]);
      setImage("");
    }
  }, [category]);
  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const res = await axios.get("/attributes");
        setAllAttributes(res.data.data); // فرض می‌کنیم API برمی‌گردونه {status:true,data:[...]}
      } catch (err) {
        console.error("Error getting features", err);
      }
    };
    fetchAttributes();
  }, []);

  // افزودن به دسته
  const handleAddAttributeToCategory = (attr) => {
    setAttributes([...attributes, attr]);
  };
  const handleAddCategory = async () => {
    const categoryData = {
      name,
      slug,
      parentId,
      attributes: attributes.map((attr) => attr._id), // فقط آیدی‌ها
      image,
    };

    try {
      const res = await axios.post("/categories", categoryData);
      // console.log("دسته با موفقیت افزوده شد:", res.data);
      onSuccess();
    } catch (error) {
      console.error("Error adding category:", error);
      alert("An error occurred while adding a category.");
    }
  };
  // تابع برای آپدیت Attribute
  const handleUpdateAttribute = async (attrId, newData) => {
    try {
      const res = await axios.put(`/attributes/${attrId}`, newData);
      // console.log("Attribute ویرایش شد:", res.data);

      if (res.data.status) {
        alert("Attribute changes saved successfully.");
        // می‌تونی اینجا لیست رو رفرش کنی یا state رو آپدیت کنی
      } else {
        alert("ذخیره ویژگی موفق نبود.");
      }
    } catch (error) {
      // console.error("Error editing feature:", error);
      alert("An error occurred while editing the property.");
    }
  };

  const handleUpdateCategory = async () => {
    const categoryData = {
      name,
      slug,
      parentId,
      attributes: attributes.map((attr) => attr._id), // فقط آیدی‌ها
      image,
    };

    try {
      const res = await axios.put(`/categories/${category._id}`, categoryData);
      // console.log("دسته ویرایش شد:", res.data);
      onSuccess();
    } catch (error) {
      // console.error("خطا در ویرایش دسته:", error);
      alert("An error occurred while editing the category.");
    }
  };

  const handleDeleteImage = (imgUrl) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    axios
      .delete("/categories/delete-image", {
        data: {
          categoryId: category._id,
          imageUrl: imgUrl,
        },
      })
      .then((res) => {
        // console.log("اطلاعات جدید از سرور:", res.data.category);
        setCategory(res.data.category); // اطلاعات جدید از سرور
        setImage(res.data.category.image);
      })

      .catch((err) => {
        // console.error("خطا در حذف تصویر:", err);
        alert("An error occurred while deleting the image.");
      });
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("categoryId", category._id);

    axios
      .post("/categories/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Image uploaded:", res.data);
        setImage(res.data.url); // اینجا دیگه آرایه نمیسازیم
      })
      .catch((err) => {
        console.error("Upload error:", err);
      });
  };
  const handleSubmit = () => {
    if (category?._id) {
      handleUpdateCategory();
    } else {
      handleAddCategory();
    }
  };
  return (
    <LinearLayout
      bgcolor="white"
      orientation="vertical"
      height="match-parent"
      width="match-parent"
      className="product-form-container"
    >
      <h4 className="form-title">
        {category ? "Edit Category" : "Add Category"}
      </h4>

      {/* 🧩 بخش اطلاعات اصلی */}
      <h5 className="form-section">Basic Information</h5>
      <LinearLayout orientation="horizontal" className="form-row">
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Name"
          value={name}
          onChange={setName}
        />
        <BasicInput
          bsize="1"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          scolor="primary"
          text="Slug"
          value={slug}
          onChange={setSlug}
        />
      </LinearLayout>

      <SelectBox
        value={parentId}
        onChange={setParentId}
        array={categories}
        text="Parent"
        bcolor="primary"
        textcolor="dark"
        bgcolor="white"
        margin="2"
      />

      <hr />

      {/* 🖼️ تصویر محصول */}
      {/* 🖼️ تصویر دسته */}
      <h5 className="form-section">Category Image</h5>
      <LinearLayout orientation="vertical" className="form-row">
        <FileInput
          bsize="2"
          bcolor="primary"
          margin="2"
          bgcolor="white"
          textcolor="black"
          handleFileChange={handleFileChange}
          handleUpload={handleUpload}
        />

        {image && (
          <div className="image-preview">
            <BootImage
              margin="1"
              padding="0"
              src={`${image}`}
              type="rounded"
              alt="uploaded-category"
            >
              <Badge
                top="5px"
                start="203px"
                color="danger"
                text={<FaTimes className="mb-1"/>}
                onClick={() => {
                  if (category?._id) {
                    handleDeleteImage(image); // حذف از بک‌اند
                  } else {
                    setImage(""); // فقط حذف محلی
                  }
                }}
              />
            </BootImage>
          </div>
        )}
      </LinearLayout>

      <hr />
      <h5 className="form-section">Category Attribute</h5>
      {attributes.map((attr, index) => (
        <LinearLayout
          height="match-parent"
          width="match-parent"
          ygravity="center"
          className="mb-3 border-bottom"
          key={index}
          orientation="horizontal"
        >
          <LinearLayout key={index} width="wrap-content" orientation="vertical">
            <ButtonSimp
              margin="0"
              size="sm"
              font="0"
              color="danger"
              padding="1"
              text=""
              className="mt-0 "
              clicked={() => {
                const updated = attributes.filter((_, i) => i !== index);
                setAttributes(updated);
              }}
            >
              <FaTimes />
            </ButtonSimp>
            <ButtonSimp
              margin="0"
              size="sm"
              font="0"
              color="success"
              padding="1"
              text=""
              className="mt-1 mb-1"
              clicked={() =>
                handleUpdateAttribute(attr._id, {
                  name: attributes[index].name,
                  type: attributes[index].type,
                  options: attributes[index].options,
                  isFilterable: attributes[index].isFilterable,
                })
              }
            >
              <FaRegSave />
            </ButtonSimp>
          </LinearLayout>

          <LinearLayout
            key={index}
            orientation="vertical"
            className="form-row "
          >
            <LinearLayout
              key={index}
              orientation="horizontal"
              className="form-row "
            >
              <BasicInput
                text="Attribute"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
                className="mb-2"
                value={attr.name}
                onChange={(value) => {
                  const updated = [...attributes];
                  updated[index].name = value;
                  setAttributes(updated);
                }}
              />
              <SelectBox
                text="Type"
                value={attr.type}
                onChange={(value) => {
                  const updated = [...attributes];
                  updated[index].type = value;
                  if (value === "select" && !updated[index].options) {
                    updated[index].options = [""];
                  }
                  setAttributes(updated);
                }}
                array={[
                  { _id: "text", name: "text" },
                  { _id: "number", name: "number" },
                  { _id: "select", name: "selective" },
                  { _id: "boolean", name: "Yes/No" },
                ]}
                bcolor="primary"
                margin="0"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
                className="m-2 m-md-0 mt-md-2"
              />{" "}
              <SelectBox
                value={attr.isFilterable ? "Yes" : "No"}
                onChange={(value) => {
                  const updated = [...attributes];
                  updated[index].isFilterable = value === "Yes"; // 👈 تبدیل به boolean
                  setAttributes(updated);
                }}
                array={[
                  { _id: "Yes", name: "Yes" },
                  { _id: "No", name: "No" },
                ]}
                text="Filterable"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                scolor="primary"
              />
            </LinearLayout>
            <LinearLayout
              key={index}
              orientation="horizontal"
              className="form-row "
              width="match-parent"
            >
              {attr.type === "select" && (
                <BasicInput
                  text="Options(separate with , )"
                  className="pe-2 mb-2"
                  value={attr.options?.join(",") || ""}
                  onChange={(value) => {
                    const updated = [...attributes];
                    updated[index].options = value.split(",");
                    setAttributes(updated);
                  }}
                  bcolor="primary"
                  margin="1"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                />
              )}
              {/* {attr.isFilterable === "Yes" && (
                <BasicInput
                  text="Filter(separate with , )"
                  className="pe-2 mb-2"
                  value={""}
                  onChange={setNewAttrOptions}
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                />
              )} */}
            </LinearLayout>
          </LinearLayout>

          {/* دکمه حذف ویژگی */}
        </LinearLayout>
      ))}
      <LinearLayout
        orientation="vertical"
        width="match-parent"
        xgravity="center"
        className="form-row"
      >
        <SelectBox
          value=""
          onChange={(value) => {
            if (value === "__new__") {
              setAddingAttr(true);
            } else {
              const selectedAttr = allAttributes.find((a) => a._id === value);
              if (selectedAttr) {
                handleAddAttributeToCategory(selectedAttr);
              }
            }
          }}
          array={[
            { _id: "__new__", name: "+ Add New Attribute" },
            ...allAttributes,
          ]}
          text={"New Attribute"}
          bcolor="primary"
          textcolor="dark"
          bgcolor="white"
          margin="2"
        />

        {addingAttr && (
          <LinearLayout
            height="match-parent"
            width="match-parent"
            className="mb-3"
            orientation="horizontal"
            ygravity="center"
          >
            <LinearLayout
              width="wrap-content"
              height="match-parent"
              orientation="vertical"
            >
              <ButtonSimp
                margin="0"
                size="sm"
                font="0"
                color="success"
                padding="1"
                text=""
                clicked={async () => {
                  if (!newAttrName.trim()) {
                    alert("Enter the feature name.");
                    return;
                  }
                  try {
                    const res = await axios.post("/attributes", {
                      name: newAttrName,
                      type: newAttrType,
                      isFilterable: filterable === "Yes" ? true : false,
                      options:
                        newAttrType === "select"
                          ? newAttrOptions.split(",").map((o) => o.trim())
                          : [],
                    });
                    handleAddAttributeToCategory(res.data.data);
                    setAllAttributes([...allAttributes, res.data.data]);
                    setNewAttrName("");
                    setNewAttrType("text");
                    setNewAttrOptions("");
                    setAddingAttr(false);
                  } catch (error) {
                    alert("Error adding feature");
                  }
                }}
              >
                <FaCheck />
              </ButtonSimp>
              <ButtonSimp
                margin="0"
                size="sm"
                font="0"
                color="danger"
                padding="1"
                text=""
                clicked={() => setAddingAttr(false)}
              >
                <FaTimes />
              </ButtonSimp>{" "}
            </LinearLayout>

            <LinearLayout
              orientation="vertical"
              className="form-row border-top border-bottom"
            >
              <LinearLayout
                orientation="horizontal"
                className="form-row mt-1"
                width="match-parent"
              >
                {" "}
                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Attribute Name"
                  value={newAttrName}
                  onChange={setNewAttrName}
                />
                <SelectBox
                  value={newAttrType}
                  onChange={setNewAttrType}
                  array={[
                    { _id: "text", name: "text" },
                    { _id: "number", name: "number" },
                    { _id: "select", name: "selective" },
                    { _id: "boolean", name: "Yes/No" },
                  ]}
                  text="Type"
                  bcolor="primary"
                  margin="0"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  className="m-2 m-md-0 mt-md-2"
                />
                <SelectBox
                  value={filterable}
                  onChange={setFilterable}
                  array={[
                    { _id: "Yes", name: "Yes" },
                    { _id: "No", name: "No" },
                  ]}
                  text="Filterable"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                />
              </LinearLayout>

              <LinearLayout
                orientation="horizontal"
                className="form-row "
                width="match-parent"
              >
                {newAttrType === "select" && (
                  <BasicInput
                    bsize="1"
                    bcolor="primary"
                    margin="2"
                    bgcolor="white"
                    textcolor="black"
                    scolor="primary"
                    text="Options(separate with , )"
                    value={newAttrOptions}
                    onChange={setNewAttrOptions}
                  />
                )}
                {/* {filterable === "Yes" && (
                  <BasicInput
                    text="Filter(separate with , )"
                    className="pe-2 mb-2"
                    value={""}
                    onChange={setNewAttrOptions}
                    bcolor="primary"
                    margin="2"
                    bgcolor="white"
                    textcolor="black"
                    scolor="primary"
                  />
                )} */}
              </LinearLayout>
            </LinearLayout>

            {/* دکمه حذف ویژگی */}
          </LinearLayout>
        )}
      </LinearLayout>

      <hr />

      {/* 🎯 دکمه‌ها */}
      <LinearLayout orientation="horizontal" justify="end">
        <ButtonSimp
          margin="2"
          size="md"
          font="6"
          color="danger"
          padding="2"
          text="Cancel"
          paddingtop="1"
          clicked={onClose}
        />
        <ButtonSimp
          margin="2"
          size="md"
          font="6"
          color="primary"
          padding="2"
          paddingtop="1"
          text="Submit"
          clicked={handleSubmit}
        />
      </LinearLayout>
    </LinearLayout>
  );
};

export default CategoryForm;
{
  /* <ButtonSimp
            margin="2"
            color="danger"
            size="sm"
            font="0"
            text=""
            clicked={() => {
              const updated = attributes.filter((_, i) => i !== index);
              setAttributes(updated);
            }}
          /> */
}
// <LinearLayout
//   bgcolor="white"
//   orientation="vertical"
//   height="match-parent"
//   width="match-parent"
//   className="overflow-auto"
// >
//   <h4>{product ? "Edit Product" : "Add Product"}</h4>
//   <LinearLayout
//     bgcolor="white"
//     orientation="horizontal"
//     height="match-parent"
//     width="match-parent"
//     className="overflow-auto"
//   >
//     <h4></h4>
//     <LinearLayout
//       bgcolor="white"
//       orientation="vertical"
//       height="match-parent"
//       width="match-parent"
//       className="overflow-auto"
//     >
//       <SelectBox
//         name=""
//         value={categoryId}
//         onChange={(val) => setCategoryId(val)}
//         array={categories}
//         margin="2"
//         bcolor="primary"
//         textcolor="dark"
//         bgcolor="white"
//         text="Category"
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Title"
//         value={title}
//         onChange={setTitle}
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Slug"
//         value={slug}
//         onChange={setSlug}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Description"
//         value={description}
//         onChange={setDescription}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Price"
//         value={price}
//         onChange={setPrice}
//       />
//     </LinearLayout>
//     <LinearLayout
//       bgcolor="white"
//       orientation="vertical"
//       height="match-parent"
//       width="match-parent"
//       className="overflow-auto"
//     >
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Discount"
//         value={discount}
//         onChange={setDiscount}
//       />

//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Stock"
//         value={stock}
//         onChange={setStock}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Color"
//         value={color}
//         onChange={setColor}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Size"
//         value={size}
//         onChange={setSize}
//       />
//       <BasicInput
//         bsize="1"
//         bcolor="primary"
//         margin="2"
//         bgcolor="white"
//         textcolor="black"
//         scolor="primary"
//         text="Brand"
//         value={brand}
//         onChange={setBrand}
//       />
//     </LinearLayout>
//   </LinearLayout>
//   <FileInput
//     bsize="2"
//     bcolor="primary"
//     margin="2"
//     bgcolor="white"
//     textcolor="black"
//   />
//   <LinearLayout
//     bgcolor="white"
//     orientation="horizontal"
//     height="match-parent"
//     width="match-parent"
//     className="overflow-auto"
//   >
//     <ButtonSimp
//       margin="2"
//       size="md"
//       font="6"
//       color="danger"
//       padding="2"
//       text="Cancel"
//       clicked={onClose}
//     />
//     <ButtonSimp
//       margin="2"
//       size="md"
//       font="6"
//       color="primary"
//       padding="2"
//       text="Submit"
//       clicked={handleSubmit}
//     />
//   </LinearLayout>
// </LinearLayout>

// <div className="modal-container">
//   <div className="modal-content">
//     <h2>{product ? "ویرایش محصول" : "افزودن محصول جدید"}</h2>

//     <div className="form-section">
//       <h4>اطلاعات کلی</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="عنوان محصول"
//           value={title}
//           onChange={setTitle}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="نامک (slug)"
//           value={slug}
//           onChange={setSlug}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="توضیحات"
//           value={description}
//           onChange={setDescription}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>مشخصات فروش</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="قیمت"
//           value={price}
//           onChange={setPrice}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="تخفیف (%)"
//           value={discount}
//           onChange={setDiscount}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="موجودی"
//           value={stock}
//           onChange={setStock}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>ویژگی‌ها</h4>
//       <div className="grid">
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="رنگ"
//           value={color}
//           onChange={setColor}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="سایز"
//           value={size}
//           onChange={setSize}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="برند"
//           value={brand}
//           onChange={setBrand}
//         />
//         <BasicInput
//           bsize="1"
//           bcolor="primary"
//           margin="1"
//           bgcolor="white"
//           textcolor="black"
//           scolor="primary"
//           text="کد دسته‌بندی"
//           value={categoryId}
//           onChange={setCategoryId}
//         />
//       </div>
//     </div>

//     <div className="form-section">
//       <h4>تصاویر محصول</h4>
//       <div className="image-upload-box">
//         <input
//           type="file"
//           onChange={(e) => setSelectedFile(e.target.files[0])}
//         />
//         <button className="upload-btn" onClick={handleImageUpload}>
//           آپلود تصویر
//         </button>
//       </div>
//       <div className="image-preview">
//         {images.map((img, i) => (
//           <img key={i} src={img} alt="product" />
//         ))}
//       </div>
//     </div>

//     <div className="modal-actions">
//       <button className="save-btn" onClick={handleSubmit}>
//         ذخیره
//       </button>
//       <button className="cancel-btn" onClick={onClose}>
//         لغو
//       </button>
//     </div>
//   </div>
// </div>
// console.log("category =", categories);
// const handleUpload = async (event) => {
//   const formData = new FormData();
//   formData.append("image", event.target.files[0]);

//   try {
//     const response = await fetch(
//       process.env.REACT_APP_API_BASE_URL+"/products/upload-image",
//       {
//         method: "POST",
//         body: formData,
//       }
//     );

//     const data = await response.json();
//     console.log("Image URL:", data.url);
//   } catch (error) {
//     console.error("Upload failed:", error);
//   }
// };
// const handleUpload = async () => {
//   if (!selectedFile) return;
//   const formData = new FormData();
//   formData.append("image", selectedFile);

//   try {
//     const { data } = await axios.post("/products/upload-image", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     setImages((prev) => [...prev, data.url]);
//   } catch (err) {
//     console.error("خطا در آپلود تصویر", err);
//   }
// };

// const handleSubmit = async () => {
//   const productData = {
//     title,
//     slug,
//     description,
//     price,
//     discount,
//     stock,
//     color,
//     size,
//     brand,
//     categoryId,
//     images,
//   };

//   try {
//     if (product?._id) {
//       await axios.put(`/api/products/${product._id}`, productData);
//     } else {
//       await axios.post("/api/products", productData);
//     }
//     onSave();
//   } catch (err) {
//     console.error("خطا در ذخیره‌سازی محصول", err);
//   }
// };
